import { Component, effect, ElementRef, HostListener, signal } from '@angular/core';
import { I18nService } from '../../services/i18n.service';
import { LanguageDto } from '../../../core/api/_dtos/language.dto';

@Component({
  selector: 'app-lang-select',
  templateUrl: './lang-select.html',
  styleUrl: './lang-select.scss'
})
export class LangSelect {
  selectedLang: string | null = null;
  isOpen = signal(false);

  constructor(
    protected i18n: I18nService,
    private elRef: ElementRef
  ) {
    this.selectedLang = this.i18n.getCurrentLang();

    effect(() => {
      const changed = this.i18n.languageChanged();
      if (changed) {
        this.selectedLang = changed.lang;
      }
    });
  }

  get currentLang(): LanguageDto | undefined {
    return this.i18n.supportedLangs.find(l => l.code === this.selectedLang);
  }

  getFlagUrl(lang: LanguageDto): string {
    const code = lang.flag_code || lang.code;
    return `/assets/flags/${code}.svg`;
  }

  toggle() {
    this.isOpen.update(v => !v);
  }

  async selectLang(lang: LanguageDto) {
    this.isOpen.set(false);
    await this.i18n.changeLanguageAndRedirect(lang.code);
    this.selectedLang = lang.code;
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    if (!this.elRef.nativeElement.contains(event.target)) {
      this.isOpen.set(false);
    }
  }
}
